import { render, staticRenderFns } from "./OpenBookingDetail.vue?vue&type=template&id=aff0e60e&scoped=true"
import script from "./OpenBookingDetail.vue?vue&type=script&lang=js"
export * from "./OpenBookingDetail.vue?vue&type=script&lang=js"
import style0 from "./OpenBookingDetail.vue?vue&type=style&index=0&id=aff0e60e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff0e60e",
  null
  
)

export default component.exports